import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import Moment from "react-moment";
import dayjs from "dayjs";
import * as XLSX from 'xlsx';
import moment from "moment";
import {
  Button,
  Card,
  CardHeader,
  Form,
  CardFooter,
  CardTitle,
  Input,
  Table,
  Container,
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  ModalFooter,
} from "reactstrap";
import {
  faInfo,
  faArrowCircleUp,
  faFileExcel,
  faSyncAlt
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import ReactDatetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import projectsService from "../../services/api/projects-service";
import projectUsersService from "../../services/api/project-users-service";
import Projects from "../projects/Projects";
import salesMembershipService from "../../services/api/sales-membership-service.";
import SummaryThreeTables from "./SummaryThreeTables";
import PlanSalesTable from "./PlanSalesTable";
import ReactBSAlert from "react-bootstrap-sweetalert";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import AsyncSelect from "react-select/async";
import debounce from "lodash.debounce";
// Removed older summary widgets in favor of SummaryThreeTables

const RECORDS_PER_PAGE = 10;

const selectStyles = {
  control: (base) => ({
    ...base,
    borderRadius: "0.25rem",
    borderColor: "#ced4da",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      borderColor: "#80bdff",
    },
    minHeight: "30px",
    height: "31px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    fontSize: "0.875rem",
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "0.875rem",
    color: "#6c757d",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#007bff"
      : state.isFocused
      ? "#f8f9fa"
      : null,
    fontSize: "0.875rem",
    "&:active": {
      backgroundColor: "#007bff",
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "5px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "5px",
  }),
};

const PLATFORM_OPTIONS = [
  { value: "android", label: "Android" },
  { value: "iOS", label: "iOS" },
  { value: "web", label: "Web" },
];

const TYPE_OPTIONS = [
  { value: "onetime", label: "One time" },
  { value: "recurring", label: "Recurring" },
];

const CURRENCY_OPTIONS = [
  { value: "INR", label: "INR" },
  { value: "USD", label: "USD" },
];
const DATE_RANGE_OPTIONS = [
  { value: "24h", label: "24 Hours" },
  { value: "7d", label: "7 Days" },
  { value: "30d", label: "30 Days" },
  { value: "12m", label: "12 Months" },
];

const AVAILABLE_EXPORT_FIELDS = [
  { label: "User Email or Phone no.", key: "user_id" },
  { label: "Currency", key: "currency" },
  { label: "Marketing Fee", key: "marketing_fee" },
  { label: "PG Commission", key: "pg_commission" },
  { label: "Platform Fee", key: "platform_fee" },
  { label: "TXN Amount", key: "txn_amount" },
  { label: "Created At", key: "createdAt" },
];

const SalesMembership = () => {
  const location = useLocation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [projectDetails, setProjectDetails] = useState({});
  const [userNameArray, setUserNames] = useState([]);
  const [alert, setAlert] = useState(null);
  const [salesMembership, setSalesMembership] = useState([]);
  const [salesCount, setSalesCount] = useState(0);
  const [gateways, setGateways] = useState([]);
  const [planId, setPlanId] = useState([]);
  const [dateRange, setDateRangeValue] = useState("24h");
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [exportFields, setExportFields] = useState([]);
  const [exportError, setExportError] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [previewColumns, setPreviewColumns] = useState([]);
  const [excelBlob, setExcelBlob] = useState(null);
  const [fileName, setFileName] = useState(""); 
  const [orderedFields, setOrderedFields] = useState([...AVAILABLE_EXPORT_FIELDS]);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedOverItem, setDraggedOverItem] = useState(null);

  const initFromURL = () => {
    const urlParams = new URLSearchParams(location.search);
    const projectId = urlParams.get("projectid");

    return {
      user_id: urlParams.get("user_id") || "",
      subscription_id: urlParams.get("subscription_id") || "",
      pg_subscription_id: urlParams.get("pg_subscription_id") || "",
      from_date: urlParams.get("from_date") || "",
      to_date: urlParams.get("to_date") || "",
      project_id: projectId || "",
      payment_type: urlParams.get("payment_type") || "",
      plan_id: urlParams.get("plan_id") || "",
      payment_gateway: urlParams.get("payment_gateway") || "",
      currency: urlParams.get("currency") || "",
      platform: urlParams.get("platform") || "",
    };
  };

  const [formState, setFormState] = useState(initFromURL);

  const activeFiltersRef = useRef({ ...initFromURL() });

  const [activePage, setActivePage] = useState(() => {
    const urlParams = new URLSearchParams(location.search);
    return parseInt(urlParams.get("page") || "1", 10);
  });

  const projectId = useMemo(
    () => new URLSearchParams(location.search).get("projectid"),
    [location.search]
  );

  const confirmReprocessEpaper = useCallback((sale) => {

    const handleReprocess = async () => {
      try {
        const response = await salesMembershipService.reprocessEpaperPlan(sale.pg_subscription_id, sale.plan_id, sale.transaction_id, sale.subscription_id._id); // Replace with your actual API function and parameters
        setAlert(null);
        console.log("Reprocess successful:", response);
        if (response?.data?.status && response?.data?.data?.status) {
          toast.success("Epaper Combo Plan reprocessed successfully!");
        }
        else {
          toast.error("An unexpected error occurred");
        }
      } catch (error) {
        // Handle error (optional)
        console.error("Reprocess failed:", error);
        setAlert(null); // Close the alert
        toast.error("Failed to reprocess Epaper Combo Plan.");
      }
    };

    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Do you want to reprocess this Epaper Combo Plan?"
        onConfirm={() => {handleReprocess(sale)}} // Define this function as needed
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, reprocess"
        cancelBtnText="No"
        showCancel
      >
        <p>This action will reprocess the selected Epaper Combo Plan.</p>
      </ReactBSAlert>
    );
  }, []);

  const updateURL = useCallback(() => {
    const params = new URLSearchParams();

    if (projectId) {
      params.set("projectid", projectId);
    }

    Object.entries(formState).forEach(([key, value]) => {
      if (value && key !== "project_id") {
        params.set(key, value);
      }
    });

    if (activePage > 1) {
      params.set("page", activePage.toString());
    }

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  }, [formState, activePage, projectId, history, location.pathname]);

  useEffect(() => {
    updateURL();
  }, [formState, activePage, updateURL]);

  // const fetchProjectUsers = useCallback(async () => {
  //   if (!projectId) return;
  //   try {
  //     const response = await projectUsersService.fetchUsers({
  //       project_id: projectId,
  //       page: 1,
  //       page_size: "",
  //     });
  //     if (response?.status && response?.data?.users) {
  //       const users = response.data.users.map((user) => ({
  //         value: user.user_id,
  //         label: user.email
  //           ? `${user.name} (${user.email})`
  //           : `${user.name} ${user.phone_number}`,
  //         email: user.email,
  //       }));
  //       setUserNames(users);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //   }
  // }, [projectId]);


  const debouncedFetchUserOptions = debounce(async (inputValue, callback, projectId, setUserNames) => {
    try {
      const users = await projectUsersService.fetchUsers({
        project_id: projectId,
        search: inputValue,
        page: 1,
        page_size: "",
      });
  
      if (users?.status && users?.data?.users) {
        const options = users.data.users.map((user) => ({
          value: user.user_id,
          label: user.email
            ? `${user.name} (${user.email})`
            : `${user.name} ${user.phone_number}`,
          email: user.email,
        }));
  
        setUserNames(options);      // Store for default value display
        callback(options);            // Return to AsyncSelect
      } else {
        setUserNames([]);
        callback([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUserNames([]);
      callback([]);
    }
  }, 500);
  
  
  const fetchUserOptions = useCallback(
    (inputValue) =>
      new Promise((resolve) => {
        if (!projectId) return resolve([]);
        debouncedFetchUserOptions(inputValue, resolve, projectId, setUserNames);
      }),
    [projectId, setUserNames]
  );
  const fetchGateways = useCallback(async () => {
    if (!projectId) return;
    try {
      const response = await salesMembershipService.getAllPaymentGateways();
      if (response.status === true && response.data) {
        const formattedGateways = response.data.map((gateway) => ({
          value: gateway,
          label: gateway
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        }));
        setGateways(formattedGateways);
      }
    } catch (error) {
      console.error("Error fetching gateways:", error);
    }
  }, [projectId]);

 
  const fetchSalesMembership = useCallback(async () => {
    if (!projectId) return;
    setIsLoading(true);
    try {
      const response = await salesMembershipService.getSalesMembership(
        activeFiltersRef.current, // Use active filters instead of formState
        activePage,
        RECORDS_PER_PAGE
      );

      if (response.status && response.data) {
        setSalesMembership(response.data?.sales?.allsalesMembership);
        setSalesCount(response?.data?.count);
      }
    } catch (error) {
      console.error("Error fetching Memberships:", error);
    } finally {
      setIsLoading(false);
    }
  }, [projectId, activePage]); // Removed formState dependency

  const fetchPlanId = useCallback(async () => {
    if (!projectId) return;
    try {
      const response = await salesMembershipService.getAllPlanId();
      if (response.status === true && response.data) {
        const formattedPlanId = response.data.map((planId) => ({
          value: planId,
          label: planId
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        }));
        setPlanId(formattedPlanId);
      }
    } catch (error) {
      console.error("Error fetching gateways:", error);
    }
  }, [projectId]);

  useEffect(() => {
    fetchPlanId();
  }, [fetchPlanId]);

  // Initial data load
  useEffect(() => {
    if (projectId) {
      activeFiltersRef.current = { ...formState };
      fetchSalesMembership();
    }
  }, [projectId]); // Only runs when projectId changes or on mount

  // Handle page changes
  useEffect(() => {
    if (projectId && Object.keys(activeFiltersRef.current).length > 0) {
      fetchSalesMembership();
    }
  }, [activePage, fetchSalesMembership, projectId]);

  // useEffect(() => {
  //   fetchProjectUsers();
  // }, [fetchProjectUsers]);

  useEffect(() => {
    fetchGateways();
  }, [fetchGateways]);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!projectId) return;
      try {
        const result = await projectsService.getProjectDetails(projectId);
        if (result?.status) {
          setProjectDetails(result.data);
        }
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };
    fetchProjectDetails();
  }, [projectId]);

  const handleFormChange = useCallback((field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  }, []);

  // Modified to update activeFiltersRef before fetching
  const handleSearch = useCallback(
    (e) => {
      e?.preventDefault();
      setActivePage(1);

      // Update active filters with current form state
      activeFiltersRef.current = { ...formState };

      // Then fetch with updated filters
      fetchSalesMembership();
    },
    [fetchSalesMembership, formState]
  );

  const handleReset = useCallback(() => {
    const resetState = {
      user_id: "",
      subscription_id: "",
      pg_subscription_id: "",
      from_date: "",
      to_date: "",
      project_id: projectId,
      payment_type: "",
      plan_id: "",
      payment_gateway: "",
      platform: "",
    };

    setExportError("");

    setFormState(resetState);
    setActivePage(1);

    // Update active filters with reset values
    activeFiltersRef.current = { ...resetState };

    const params = new URLSearchParams();
    if (projectId) {
      params.set("projectid", projectId);
    }

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });

    // Fetch with reset filters
    fetchSalesMembership();
  }, [projectId, history, location.pathname, fetchSalesMembership]);
  

  const setDateRange = (duration) => {
    const now = dayjs();
    let fromDate;

    switch (duration) {
      case "24h":
        fromDate = now.subtract(24, "hour");
        break;
      case "7d":
        fromDate = now.subtract(7, "day");
        break;
      case "30d":
        fromDate = now.subtract(30, "day");
        break;
      case "12m":
        fromDate = now.subtract(12, "month");
        break;
      default:
        fromDate = now;
    }

    handleFormChange("from_date", fromDate.format("YYYY-MM-DD HH:mm:ss"));
    handleFormChange("to_date", now.format("YYYY-MM-DD HH:mm:ss"));
    setDateRangeValue(duration);
  };

  const handleClickUser = useCallback(
    (projectId, userId) => {
      if (!projectId || !userId) return;

      history.push(
        `/dashboard/user-detailed-view?userid=${userId}&projectid=${projectId}`
      );
    },
    [history]
  );

  const handleClickSubs = useCallback(
    (projectId, pg_subscription_id) => {
      if (!projectId || !pg_subscription_id) return;

      history.push(
        `/membership/subscription?subscription_id=${pg_subscription_id}&projectid=${projectId}`
      );
    },
    [history]
  );



  
  const toggleExportModal = () => {
    setExportModalOpen(!exportModalOpen);
    setExportError("");
  };

  const validateFormState = () => {
    const errors = {};

    if (formState.from_date && formState.to_date) {
      const startDate = new Date(formState.from_date);
      const endDate = new Date(formState.to_date);

      if (startDate > endDate) {
        errors.end_date = "End date must be after start date";
        setValidationErrors(errors);
        setExportError("End date must be after start date.");
        return false;
      }

      const monthDiff =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());
      if (monthDiff > 2) {
        errors.end_date = "Date range must be between less than 2 months.";
        setExportError("Date range must be between less than 2 months.");
        setValidationErrors(errors);
        return false;
      }
    }
    setValidationErrors({});
    return true;
  };

  useEffect(() => {
    if (!exportModalOpen) {
      // Reset preview state when modal is closed
      setIsPreviewMode(false);
      setPreviewData([]);
      setPreviewColumns([]);
      setExportError("");
    }
  }, [exportModalOpen]);

  // Select or deselect all fields
  const handleSelectAll = () => {
    if (exportFields.length === orderedFields.length) {
      setExportFields([]);
    } else {
      setExportFields(orderedFields.map(field => field.key));
    }
  };

  // Toggle individual field selections
  const handleFieldSelection = (e, fieldKey) => {
    // Stop propagation to prevent triggering drag events
    e.stopPropagation();
    
    if (exportFields.includes(fieldKey)) {
      setExportFields(exportFields.filter(f => f !== fieldKey));
    } else {
      setExportFields([...exportFields, fieldKey]);
    }
  };

  // Drag and drop handlers
  const handleDragStart = (e, index) => {
    // Add data to the drag event so it works properly
    e.dataTransfer.setData('text/plain', index);
    e.dataTransfer.effectAllowed = 'move';
    
    // Set a small delay to make the drag preview look better
    setTimeout(() => {
      setDraggedItem(index);
    }, 0);
  };

  const handleDragOver = (e, index) => {
    // Prevent default to allow drop
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    if (draggedItem !== index) {
      setDraggedOverItem(index);
    }
  };
  
  const handleDragEnter = (e, index) => {
    e.preventDefault();
    if (draggedItem !== index) {
      setDraggedOverItem(index);
    }
  };
  
  const handleDragLeave = (e) => {
    e.preventDefault();
    setDraggedOverItem(null);
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    
    const draggedIndex = Number(e.dataTransfer.getData('text/plain'));
    
    if (draggedIndex !== index) {
      // Create a copy of the ordered fields
      const newOrderedFields = [...orderedFields];
      
      // Remove the dragged item
      const [draggedField] = newOrderedFields.splice(draggedIndex, 1);
      
      // Insert it at the new position
      newOrderedFields.splice(index, 0, draggedField);
      
      // Update state
      setOrderedFields(newOrderedFields);
    }
    
    // Reset drag state
    setDraggedItem(null);
    setDraggedOverItem(null);
  };
  
  const handleDragEnd = (e) => {
    e.preventDefault();
    // Reset drag state
    setDraggedItem(null);
    setDraggedOverItem(null);
  };

  const handleCloseModal = () => {
    // Reset state and close modal
    setIsPreviewMode(false);
    setPreviewData([]);
    setPreviewColumns([]);
    setExportError("");
    toggleExportModal();
    setOrderedFields([...AVAILABLE_EXPORT_FIELDS]); // Reset to default order
    setExportFields([]);
  };
  const handleExport = () => {
    if (excelBlob && fileName) {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(excelBlob);
      link.download = fileName;
      link.click();
    } else {
      handlePreview();
    }
  };


  const handlePreview = async () => {
    if (!salesMembership.length) {
      setExportError("No sales found");
      return;
    }
    if (!validateFormState()) return;


 if (exportFields.length === 0) {
      setExportError("Please select at least one field to export.");
      return;
    }
    try {
    console.log(orderedFields)
      const selectedOrderedFields = orderedFields
        .filter(field => exportFields.includes(field.key))
        .map(field => field.key);
      
        console.log(selectedOrderedFields)
      const exportParams = {
        formdata: activeFiltersRef.current,
        fields: selectedOrderedFields, // Use the ordered list of selected fields
      };

      // Show loading state
      setExportError("Loading preview...");
      
      // Fetch data for preview
      const response = await salesMembershipService.exportSales(exportParams);

      if (response?.data) {
        // Create blob and filename
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        
        // Generate filename based on date range
        const { from_date, to_date } = exportParams.formdata;
        const startDate = from_date
          ? moment(from_date).format("YYYYMMDD")
          : moment().subtract(2, "months").format("YYYYMMDD");
        const endDate = to_date
          ? moment(to_date).format("YYYYMMDD")
          : moment().format("YYYYMMDD");
        const projectNameSafe = projectDetails.name
          ? projectDetails.name.replace(/\s+/g, "_")
          : "export";
        const fileName = `SalesMembership-${projectNameSafe}-${startDate}-to-${endDate}.xlsx`;
        
        // Save blob and filename for later download
        setExcelBlob(blob);
        setFileName(fileName);
        
        // Parse Excel data for preview
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Get the first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          
          // Extract columns for the table header (these should now be in the correct order)
          const columns = Object.keys(jsonData[0] || {});
          
          // Update state with preview data
          setPreviewData(jsonData);
          setPreviewColumns(columns);
          setIsPreviewMode(true);
          setExportError("");
        };
        
        fileReader.readAsArrayBuffer(blob);
      } else {
        setExportError(
          "Failed to generate preview. Invalid response from server."
        );
      }
    } catch (err) {
      console.error("Error generating preview:", err);
      setExportError(
        "Failed to generate preview. Please try again later."
      );
    }
  };

  const renderSalesRows = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan="8" className="text-center">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </td>
        </tr>
      );
    }

    if (!salesMembership.length) {
      return (
        <tr>
          <td colSpan="8" className="text-center">
            <CardTitle tag="h4">No Records Found</CardTitle>
          </td>
        </tr>
      );
    }

    return salesMembership.map((sales, index) => {
      const rowNumber = RECORDS_PER_PAGE * (activePage - 1) + index + 1;

      return (
        <tr key={sales.id}>
          <td className="text-left">{rowNumber}</td>
          <td
            style={{ cursor: "pointer" }}
            className="text-left "
            onClick={() => handleClickUser(projectId, sales?.user_id?._id)}
          >
            {sales?.user_id?.email || sales?.user_id?.phone_number ? (
              <>
                {sales?.user_id?.email && <div>{sales.user_id.email}</div>}
                {sales?.user_id?.phone_number && (
                  <div>{sales.user_id.phone_number}</div>
                )}
              </>
            ) : (
              "-"
            )}
          </td>
          <td className="text-left">{sales?.plan_id}</td>
          <td
            style={{ cursor: "pointer", color: "#0077b6" }}
            onClick={() =>
              handleClickSubs(
                projectId,
                sales?.subscription_id?.pg_subscription_id
              )
            }
          >
            {sales?.subscription_id?.pg_subscription_id || ""}
          </td>

          <td className="text-left">{sales.payment_gateway || ""}</td>
          <td className="text-left">
            {sales.payment_type === "onetime" ? "One time" : "Recurring"}
          </td>
          <td className="text-left">
            {sales.currency === "INR"
              ? `₹${new Intl.NumberFormat("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(sales.txn_amount || 0)}`
              : `$${new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(sales.txn_amount || 0)}`}
          </td>

          <td className="text-center">
            {(sales.currency_conversion_rate || 0).toFixed(2) || ""}
          </td>
          <td className="text-left">
            {"₹"}{(sales.txn_amount_inr || 0).toFixed(2) || ""}
          </td>

          <td className="text-left">
            <Moment format="DD MMM YYYY, hh:mm A">{sales.createdAt}</Moment>
          </td>
          <td>
            <div className="d-flex align-items-center gap-1">
              <Button
                className="btn-icon btn-round"
                color="info"
                size="sm"
                title="View Details"
                onClick={() =>
                  history.push(
                    `/membership/sales-membership-details/${sales._id}`
                  )
                }
              >
                <FontAwesomeIcon icon={faInfo} />
              </Button>
              {["plan_inr_epaper_combo_yearly", "plan_usd_epaper_combo_yearly", "plan_inr_epaper_combo_30_months", "plan_usd_epaper_combo_30_months"].includes(sales.plan_id) &&
               (
                  <Button
                    className="btn btn-icon btn-round btn-sm ml-1 btn-success d-flex align-items-center justify-content-center"
                    style={{ width: '32px', height: '32px' }}
                    size="sm"
                    onClick={() => confirmReprocessEpaper(sales)} // You should define this handler
                  >
                    <FontAwesomeIcon icon={faSyncAlt} title="Reprocess Combo Plan" className="text-center" /> {/* or any icon you prefer */}
                  </Button>
                )}
            </div>
          </td>
        </tr>
      );
    });
  };

  if (!projectId) {
    return <Projects navigate="membership/sales-membership" feature="sales_membership" />;
  }

  return (
    <div  className="content d-flex justify-content-center" style={{ minHeight: '100vh' }}>
      {alert}
      <Container>
        <Card className="card-signup">
          <CardHeader className="bg-white p-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
              {/* Left Side (Title + Project Name) */}
              <div className="mb-2 mb-md-0">
                <h4 className="mb-0">
                  Sales Membership Dashboard{" "}
                  <small className="text-muted">
                    {projectDetails.name ? `(${projectDetails.name})` : "(Project Name)"}
                  </small>
                </h4>
              </div>

              {/* Right Side (Buttons + Date Filter) */}
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 w-md-auto">
                <Link
                  to={`subscription?projectid=${projectId}`}
                  className="d-flex align-items-center text-info border rounded px-3 py-1 mb-2 mb-md-0 mr-md-2"
                  title="Go to Sales Dashboard"
                  style={{ textDecoration: "none" }}
                >
                  <span className="mr-2">Membership Dashboard</span>
                  <FontAwesomeIcon
                    icon={faArrowCircleUp}
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                  />
                </Link>

                <div style={{ minWidth: "150px" }}>
                  <Select
                    isClearable
                    placeholder="Date Range"
                    options={DATE_RANGE_OPTIONS}
                    styles={selectStyles}
                    onChange={(option) => {
                      if (option?.value) {
                        setDateRange(option.value);
                      } else {
                        handleFormChange("from_date", "");
                        handleFormChange("to_date", "");
                      }
                    }}
                    className="date-range-select"
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: "#007bff",
                        primary25: "#e6f2ff",
                      },
                    })}
                  />
                </div>
              </div>
            </div>

            <style>{`
              .fifth-col { flex: 0 0 20%; max-width: 20%; padding-left: 8px; padding-right: 8px; }
              @media (max-width: 1400px) { .fifth-col { flex: 0 0 25%; max-width: 25%; } }
              @media (max-width: 1200px) { .fifth-col { flex: 0 0 33.333%; max-width: 33.333%; } }
              @media (max-width: 992px) { .fifth-col { flex: 0 0 50%; max-width: 50%; } }
              @media (max-width: 576px) { .fifth-col { flex: 0 0 100%; max-width: 100%; } }
            `}</style>
            <Row>
              <Col md="12">
                <SummaryThreeTables formState={formState} />
              </Col>
            </Row>
            
            <Row>
              <Col md="12">
                <PlanSalesTable formState={formState} />
              </Col>
            </Row>
        

            <Form id="transactionfilters" onSubmit={handleSearch}>
              <Row>
                <Col md="3">
                  <Input
                    type="text"
                    placeholder="PG Subscription Id"
                    value={formState.pg_subscription_id}
                    onChange={(e) =>
                      handleFormChange("pg_subscription_id", e.target.value)
                    }
                  />
                </Col>

                <Col md="3">
                  <Select
                    isMulti
                    isClearable
                    placeholder="Select Plan Id"
                    options={planId}
                    value={planId.filter((option) =>
                      formState.plan_id.includes(option.value)
                    )}
                    onChange={(selectedOptions) =>
                      handleFormChange(
                        "plan_id",
                        selectedOptions
                          ? selectedOptions.map((opt) => opt.value)
                          : []
                      )
                    }
                  />
                </Col>
                <Col md="3">
                  <ReactDatetime
                    value={formState.from_date}
                    onChange={(date) => handleFormChange("from_date", date._d)}
                    inputProps={{
                      className: "form-control",
                      placeholder: "From Date",
                    }}
                  />
                </Col>

                <Col md="3">
                  <ReactDatetime
                    value={formState.to_date}
                    onChange={(date) => handleFormChange("to_date", date._d)}
                    inputProps={{
                      className: "form-control",
                      placeholder: "To Date",
                    }}
                    timeFormat="HH:mm"
                    defaultValue={new Date().setHours(23, 59, 0, 0)}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="3">
                  <AsyncSelect
                    isClearable
                    placeholder="Select User"
                    defaultOptions={false}
                    loadOptions={fetchUserOptions} // now debounced
                    onChange={(option) =>
                      handleFormChange("user_id", option?.value || "")
                    }
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? "No users found" : "Search to get options"
                    }
                    value={
                      formState.user_id
                        ? {
                          value: formState.user_id,
                          label:
                            userNameArray.find((u) => u.value === formState.user_id)?.label ||
                            "Selected User",
                        }
                        : null
                    }
                  />
                </Col>

                <Col md="3">
                  <Select
                    isClearable
                    placeholder="Sales Membership Type"
                    options={TYPE_OPTIONS}
                    value={
                      TYPE_OPTIONS.find(
                        (option) => option.value === formState.payment_type
                      ) || null
                    }
                    onChange={(option) =>
                      handleFormChange("payment_type", option?.value)
                    }
                  />
                </Col>

                <Col md="3">
                  <Select
                    isMulti
                    isClearable
                    placeholder="Select Payment Gateway"
                    options={gateways}
                    value={gateways.filter((option) =>
                      formState.payment_gateway.includes(option.value)
                    )}
                    onChange={(selectedOptions) =>
                      handleFormChange(
                        "payment_gateway",
                        selectedOptions
                          ? selectedOptions.map((opt) => opt.value)
                          : []
                      )
                    }
                  />
                </Col>

                <Col md="3">
                  <Select
                    isClearable
                    placeholder="Currency"
                    options={CURRENCY_OPTIONS}
                    value={
                      CURRENCY_OPTIONS.find(
                        (option) => option.value === formState.currency
                      ) || null
                    }
                    onChange={(option) =>
                      handleFormChange("currency", option?.value)
                    }
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                  <Col md="3">
                  <Select
                    isClearable
                    placeholder="Platform"
                    options={PLATFORM_OPTIONS}
                    value={
                      PLATFORM_OPTIONS.find(
                        (option) => option.value === formState.platform
                      ) || null
                    }
                    onChange={(option) =>
                      handleFormChange("platform", option?.value)
                    }
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md="6">
                  <Button className="btn-round mr-2" color="info" type="submit">
                    Search
                  </Button>
                  <Button
                    className="btn-round"
                    color="warning"
                    type="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                  <Button
                    color="success"
                    onClick={toggleExportModal}
                    className="btn-round mr-2"
                  >
                    <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                    User Excel
                  </Button>
                </Col>
              </Row>
            </Form>

            <hr />
            {salesCount > 0 ? (
              <Row>
                <Col md="6">
                  <div style={{ float: "right", margin: "5px" }}>
                    <b>
                      {" "}
                      {(activePage - 1) * RECORDS_PER_PAGE + 1} -{" "}
                      {Math.min(activePage * RECORDS_PER_PAGE, salesCount)} of{" "}
                      {salesCount}
                    </b>
                  </div>
                </Col>
                <Col md="6">
                  <div style={{ float: "left" }}>
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={RECORDS_PER_PAGE}
                      totalItemsCount={salesCount}
                      pageRangeDisplayed={3}
                      onChange={setActivePage}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </Col>
              </Row>
            ) : null}

            <Table responsive>
              <thead className="text-primary">
                <tr>
                  <th className="text-left">S.no.</th>
                  <th className="text-left">User Email or Phone No.</th>
                  <th className="text-left">Plan ID</th>
                  <th className="text-left">Membership ID</th>
                  <th className="text-left">Payment Gateway</th>
                  <th className="text-left">Payment Type</th>
                  <th className="text-left">TXN Amount </th>
                  <th className="text-center">Conversion Rate </th>
                  <th className="text-left">Billing Amount </th>
                  <th className="text-center">Created At</th>
                  <th className="text-left wide-action">Action</th>
                </tr>
              </thead>
              <tbody>{renderSalesRows()}</tbody>
            </Table>
          </CardHeader>
          <Modal 
      isOpen={exportModalOpen} 
      centered 
      size={isPreviewMode ? "xl" : "md"}
    >
      <ModalHeader className="bg-light text-center">
        {isPreviewMode ? "Preview Excel Data" : "Export User Data"}
      </ModalHeader>
      <ModalBody>
        {!isPreviewMode ? (
          <FormGroup>
            <Label className="fw-bold mb-2">
              Select and Order Fields to Add in Excel File
            </Label>
            <div className="mb-3 alert alert-info">
              <small>
                <strong>Tip:</strong> The fields will appear in your Excel file in the order shown below. 
                <strong> Drag and drop</strong> fields to reorder them.
              </small>
            </div>
            <div
              className="border rounded p-2 overflow-auto"
              style={{ maxHeight: "300px" }}
            >
              <div className="fs mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="selectAll"
                  onChange={handleSelectAll}
                  checked={
                    exportFields.length === orderedFields.length
                  }
                />
                <label
                  className="form-check-label ms-2"
                  htmlFor="selectAll"
                >
                  Select All
                </label>
              </div>

              {orderedFields.map((field, index) => (
                <div 
                  className={`fs d-flex align-items-center justify-content-between border-bottom py-2 ${draggedItem === index ? 'opacity-50' : ''} ${draggedOverItem === index ? 'bg-light border border-primary' : ''}`}
                  key={field.key}
                  draggable="true"
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDragEnter={(e) => handleDragEnter(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, index)}
                  onDragEnd={handleDragEnd}
                  style={{ cursor: 'grab' }}
                >
                  <div className="d-flex align-items-center flex-grow-1">
                    <div className="drag-handle me-2 text-secondary" style={{ cursor: 'grab' }}>
                      <i className="fa fa-bars"></i>
                    </div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={field.key}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => handleFieldSelection(e, field.key)}
                      checked={exportFields.includes(field.key)}
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor={field.key}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {field.label}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </FormGroup>
        ) : (
          <div className="excel-preview">
            <div className="table-responsive" style={{ maxHeight: "400px" }}>
              <table className="table table-striped table-bordered">
                <thead className="bg-light">
                  <tr>
                    {previewColumns.map((column, index) => (
                      <th key={index}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {previewData.slice(0, 50).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {previewColumns.map((column, colIndex) => (
                        <td key={colIndex}>{row[column]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {previewData.length > 50 && (
              <div className="text-center text-muted mt-2">
                Showing first 50 records of {previewData.length} total records.
              </div>
            )}
          </div>
        )}
        {exportError && (
          <div className="text-danger text-center mt-3 small">
            {exportError}
          </div>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        {!isPreviewMode ? (
          <>
            <Button color="primary" onClick={handlePreview}>
              Preview
            </Button>
            <Button color="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
          </>
        ) : (
          <>
            <Button color="success" onClick={handleExport}>
              Download Excel
            </Button>
            <Button color="primary" onClick={() => setIsPreviewMode(false)}>
              Back to Fields
            </Button>
            <Button color="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
    
          <CardFooter>
            <hr />
          </CardFooter>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default SalesMembership;
